import AdminPanel from "./AdminPanel";
import Button from "../Button";

/**
 * Barre de filtres generique : le champ "fields" pilote entierement le
 * rendu, pour que les futurs modules ajoutent leurs propres filtres sans
 * toucher ce composant (champs texte par defaut, cas particuliers pour
 * les selects et les dates connus du domaine).
 */
export default function AdminFilter({ t, form, setForm, fields, submit }) {
  const set = (key, value) => setForm({ ...form, [key]: value });
  const select = (key, options) => (
    <select key={key} aria-label={t(`admin.${key}`)} value={form[key]} onChange={(event) => set(key, event.target.value)}>
      <option value="">{t("admin.all")}</option>
      {options.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
    </select>
  );
  const text = (key) => (
    <input key={key} aria-label={t(`admin.${key}`)} placeholder={t(`admin.${key}`)} value={form[key]} onChange={(event) => set(key, event.target.value)} />
  );
  const date = (key) => (
    <input key={key} type="date" aria-label={t(`admin.${key}`)} value={form[key]} onChange={(event) => set(key, event.target.value)} />
  );

  const renderField = (key) => {
    if (key === "search" || key === "countryCode" || key === "entityType" || key === "action" || key === "actorId") return text(key);
    if (key === "from" || key === "to") return date(key);
    if (key === "active") return select(key, [["true", t("admin.active")], ["false", t("admin.inactive")]]);
    if (key === "type") return select(key, [["all", t("admin.all")], ["lost", t("admin.lost")], ["found", t("admin.found")]]);
    if (key === "category") return select(key, [["ELECTRONIQUE", "ELECTRONIQUE"]]);
    return select(key, [["ACTIF_RECHERCHE", "ACTIF_RECHERCHE"], ["SUSPENDU", "SUSPENDU"], ["CLOTURE", "CLOTURE"]]);
  };

  return (
    <AdminPanel>
      <form onSubmit={(event) => { event.preventDefault(); submit(); }} style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {fields.map(renderField)}
        <Button type="submit" size="sm">{t("admin.filter")}</Button>
      </form>
    </AdminPanel>
  );
}
